import * as restfulService from '../../../services/restfulService'

export const buscarProcessoSeletivo = () => {
  return new Promise((resolve, reject) => {
    restfulService.get('processo-seletivo')
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const buscarCurriculos = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('buscar-curriculos', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const buscarLocaisProva = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('buscar-locais-prova', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const gravaPreIncricao = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('grava-preinscricao', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const gravaIncricao = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('grava-inscricao', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const buscarNota = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('buscar-nota', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}




// WEBPACK FOOTER //
// ./src/app/domains/vestibular/services/vestibularService.js